
import { Record, Union } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { record_type, lambda_type, unit_type, tuple_type, list_type, option_type, string_type, class_type, union_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { FileUploadResponse_$reflection } from "../../Shared/File.js";
import { ProcedureId, FormState__getValidation, FormState__setValidationResponse_5219762A, FormState__startLoading, FormState_get_empty, RequestedValue$1, NotificationId__get_unwrap, FormState_$reflection, RequestedValue$1_$reflection, ClientApiResponse$1_$reflection } from "../../Shared/Shared.js";
import { DataTransferObject_AddNotificationImageDto, DataTransferObject_AcceptAssignmentNotificationDto, ImageRole, AssignmentNotificationId, AssignmentNotificationId_$reflection, EntityType_$reflection, AssignmentNotification_$reflection } from "../../Shared/AssignmentNotification.js";
import { ImageUpload, DnDFormImage, DnDFormImage_$reflection } from "../Image/ImageUploadDnD.js";
import { OverviewNotification, NotificationProcedure, OverviewNotification_$reflection } from "../../Shared/Notification.js";
import { parse } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Guid.js";
import { addImage, removeImage, acceptNotification, getNotificationDetail } from "../../Requests/AssignmentNotification.js";
import { add, tryFind, empty, ofList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Map.js";
import { isEmpty, ofArray, tryFind as tryFind_1, tryPick, empty as empty_1, choose, singleton, filter, sortBy, mapIndexed, map } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { toLocalTime, toString, compare } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Date.js";
import { List_groupBy } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq2.js";
import { createObj, comparePrimitives, compareArrays, arrayHash, equalArrays, equals } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { Cmd_batch, Cmd_none } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { uploadImage, uploadSignature } from "../../Requests/Files.js";
import { Cmd_errorToast } from "../../Components/Toast.js";
import { difference, ofList as ofList_1 } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Set.js";
import { unwrap, map as map_1, defaultArg } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { collect, singleton as singleton_1, empty as empty_2, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { useTranslation } from "react-i18next";
import { reactElement, reactApi } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { SignatureDialog } from "../../Components/SignatureDialog.js";
import { join } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { TextValue } from "../../Components/Text.js";
import Check_Circle from "../../../public/assets/icons/Check_Circle.svg";
import { TextButton } from "../../Components/Button.js";
import { ClickableImageStrip } from "../Image/ImageStrip.js";
import { ErrorAlert } from "../../Components/Alert.js";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { OpenProcedureModal } from "../Procedure/Form/View.js";
import { Dialog } from "../../Components/Dialog.js";

export class NotificationToolType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Tool", "ToolWithQuantity", "Set", "Consumable"];
    }
}

export function NotificationToolType_$reflection() {
    return union_type("Widgets.AcceptNotificationDialog.NotificationToolType", [], NotificationToolType, () => [[], [], [], []]);
}

class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SetSignature", "UploadSignature", "SignatureUploaded", "AcceptNotification", "AcceptNotificationResponse", "FetchError", "SetSelectedProcedureId", "MarkProcedureCompleted", "DetailLoaded", "SetSelectedReceiverFiles", "ReceiverImageUploaded", "ReceiverImageRegistered", "ReceiverImageRemoved"];
    }
}

function Msg_$reflection() {
    return union_type("Widgets.AcceptNotificationDialog.Msg", [], Msg, () => [[["Item", class_type("Browser.Types.File", undefined)]], [], [["Item", FileUploadResponse_$reflection()]], [], [["Item", ClientApiResponse$1_$reflection(string_type)]], [["Item", class_type("System.Exception")]], [["Item", option_type(string_type)]], [["Item", string_type]], [["Item", AssignmentNotification_$reflection()]], [["Item1", EntityType_$reflection()], ["Item2", string_type], ["Item3", list_type(DnDFormImage_$reflection())]], [["Item1", EntityType_$reflection()], ["Item2", string_type], ["Item3", FileUploadResponse_$reflection()]], [["Item", ClientApiResponse$1_$reflection(class_type("System.Guid"))]], [["Item", ClientApiResponse$1_$reflection(string_type)]]]);
}

class State extends Record {
    constructor(Notification, AssignmentNotificationId, Detail, SelectedReceiverFilesByEntity, Signature, SignatureUrl, FormState, OnConfirm, NotificationToolType, SelectedProcedureId) {
        super();
        this.Notification = Notification;
        this.AssignmentNotificationId = AssignmentNotificationId;
        this.Detail = Detail;
        this.SelectedReceiverFilesByEntity = SelectedReceiverFilesByEntity;
        this.Signature = Signature;
        this.SignatureUrl = SignatureUrl;
        this.FormState = FormState;
        this.OnConfirm = OnConfirm;
        this.NotificationToolType = NotificationToolType;
        this.SelectedProcedureId = SelectedProcedureId;
    }
}

function State_$reflection() {
    return record_type("Widgets.AcceptNotificationDialog.State", [], State, () => [["Notification", OverviewNotification_$reflection()], ["AssignmentNotificationId", AssignmentNotificationId_$reflection()], ["Detail", RequestedValue$1_$reflection(AssignmentNotification_$reflection())], ["SelectedReceiverFilesByEntity", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [tuple_type(EntityType_$reflection(), string_type), list_type(DnDFormImage_$reflection())])], ["Signature", option_type(class_type("Browser.Types.File", undefined))], ["SignatureUrl", option_type(string_type)], ["FormState", FormState_$reflection()], ["OnConfirm", lambda_type(unit_type, unit_type)], ["NotificationToolType", NotificationToolType_$reflection()], ["SelectedProcedureId", option_type(string_type)]]);
}

function assignmentIdOf(notification) {
    return new AssignmentNotificationId(parse(NotificationId__get_unwrap(notification.Id)));
}

function loadDetailCmd(assignmentNotificationId) {
    return getNotificationDetail(assignmentNotificationId, (Item) => (new Msg(8, [Item])), (Item_1) => (new Msg(5, [Item_1])));
}

function receiverFilesByEntity(detail) {
    return ofList(map((tupledArg) => [tupledArg[0], mapIndexed((index, image) => (new DnDFormImage(1, [{
        ImageUrl: image.ImageUrl,
        Position: index + 1,
    }])), sortBy((i_2) => i_2.UploadedAt, tupledArg[1], {
        Compare: (x_1, y_1) => (compare(x_1, y_1) | 0),
    }))], List_groupBy((i_1) => [i_1.EntityType, i_1.EntityId], filter((i) => equals(i.Role, new ImageRole(1, [])), detail.Images), {
        Equals: equalArrays,
        GetHashCode: (x) => (arrayHash(x) | 0),
    })), {
        Compare: (x_2, y_2) => (compareArrays(x_2, y_2) | 0),
    });
}

function init(notificationToolType, notification, onConfirm) {
    const assignmentNotificationId = assignmentIdOf(notification);
    return [new State(notification, assignmentNotificationId, new RequestedValue$1(0, []), empty({
        Compare: (x, y) => (compareArrays(x, y) | 0),
    }), undefined, undefined, FormState_get_empty(), onConfirm, notificationToolType, undefined), loadDetailCmd(assignmentNotificationId)];
}

function update(msg, state) {
    let bind$0040;
    switch (msg.tag) {
        case 0:
            return [new State(state.Notification, state.AssignmentNotificationId, state.Detail, state.SelectedReceiverFilesByEntity, msg.fields[0], state.SignatureUrl, state.FormState, state.OnConfirm, state.NotificationToolType, state.SelectedProcedureId), Cmd_none()];
        case 1: {
            const matchValue = state.Signature;
            if (matchValue == null) {
                return [state, Cmd_none()];
            }
            else {
                const signature = matchValue;
                const formData = new FormData();
                formData.append(signature.name, signature);
                return [new State(state.Notification, state.AssignmentNotificationId, state.Detail, state.SelectedReceiverFilesByEntity, state.Signature, undefined, FormState__startLoading(state.FormState), state.OnConfirm, state.NotificationToolType, state.SelectedProcedureId), uploadSignature(formData, (Item) => (new Msg(2, [Item])), (Item_1) => (new Msg(5, [Item_1])))];
            }
        }
        case 2: {
            const response = msg.fields[0];
            switch (response.tag) {
                case 0:
                    return [state, Cmd_errorToast("general.file_too_large")];
                case 2:
                    return [state, Cmd_errorToast("general.a_error_occured")];
                default:
                    return [new State(state.Notification, state.AssignmentNotificationId, state.Detail, state.SelectedReceiverFilesByEntity, state.Signature, response.fields[0].ImageUrl, state.FormState, state.OnConfirm, state.NotificationToolType, state.SelectedProcedureId), singleton((dispatch) => {
                        dispatch(new Msg(3, []));
                    })];
            }
        }
        case 3: {
            const acceptCommand = acceptNotification(state.AssignmentNotificationId, new DataTransferObject_AcceptAssignmentNotificationDto(undefined, state.SignatureUrl), (Item_2) => (new Msg(4, [Item_2])), (Item_3) => (new Msg(5, [Item_3])));
            return [new State(state.Notification, state.AssignmentNotificationId, state.Detail, state.SelectedReceiverFilesByEntity, state.Signature, state.SignatureUrl, FormState__startLoading(state.FormState), state.OnConfirm, state.NotificationToolType, state.SelectedProcedureId), acceptCommand];
        }
        case 4: {
            const response_1 = msg.fields[0];
            if (response_1.tag === 1) {
                return [new State(state.Notification, state.AssignmentNotificationId, state.Detail, state.SelectedReceiverFilesByEntity, state.Signature, state.SignatureUrl, FormState__setValidationResponse_5219762A(state.FormState, response_1.fields[0]), state.OnConfirm, state.NotificationToolType, state.SelectedProcedureId), Cmd_none()];
            }
            else {
                state.OnConfirm();
                return [new State(state.Notification, state.AssignmentNotificationId, state.Detail, state.SelectedReceiverFilesByEntity, state.Signature, state.SignatureUrl, FormState_get_empty(), state.OnConfirm, state.NotificationToolType, state.SelectedProcedureId), Cmd_none()];
            }
        }
        case 5:
            return [new State(state.Notification, state.AssignmentNotificationId, state.Detail, state.SelectedReceiverFilesByEntity, state.Signature, state.SignatureUrl, FormState_get_empty(), state.OnConfirm, state.NotificationToolType, state.SelectedProcedureId), Cmd_none()];
        case 6:
            return [new State(state.Notification, state.AssignmentNotificationId, state.Detail, state.SelectedReceiverFilesByEntity, state.Signature, state.SignatureUrl, state.FormState, state.OnConfirm, state.NotificationToolType, msg.fields[0]), Cmd_none()];
        case 7:
            return [new State((bind$0040 = state.Notification, new OverviewNotification(bind$0040.Id, bind$0040.Receiver, bind$0040.ReceiverId, bind$0040.Sender, bind$0040.SenderId, bind$0040.EntityId, bind$0040.EntityName, bind$0040.Comment, bind$0040.PlannedReturnDate, bind$0040.WithSignature, map((p) => {
                if (p.Id === msg.fields[0]) {
                    return new NotificationProcedure(p.Id, p.TemplateName, true, p.IsMandatory, p.ProcedureTemplateId);
                }
                else {
                    return p;
                }
            }, state.Notification.Procedures), bind$0040.NotificationType, bind$0040.PausedUntil)), state.AssignmentNotificationId, state.Detail, state.SelectedReceiverFilesByEntity, state.Signature, state.SignatureUrl, state.FormState, state.OnConfirm, state.NotificationToolType, undefined), Cmd_none()];
        case 9: {
            const newFiles = msg.fields[2];
            const entityType = msg.fields[0];
            const entityId = msg.fields[1];
            const entityKey = [entityType, entityId];
            const previousUrls = ofList_1(choose((f) => {
                if (f.tag === 1) {
                    return f.fields[0].ImageUrl;
                }
                else {
                    return undefined;
                }
            }, defaultArg(tryFind(entityKey, state.SelectedReceiverFilesByEntity), empty_1())), {
                Compare: (x, y) => (comparePrimitives(x, y) | 0),
            });
            const newUrls = ofList_1(choose((f_1) => {
                if (f_1.tag === 1) {
                    return f_1.fields[0].ImageUrl;
                }
                else {
                    return undefined;
                }
            }, newFiles), {
                Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
            });
            const pickedFile = tryPick((f_2) => {
                if (f_2.tag === 0) {
                    return f_2.fields[0].File;
                }
                else {
                    return undefined;
                }
            }, newFiles);
            const removedUrls = difference(previousUrls, newUrls);
            const cmds = toList(delay(() => {
                let matchValue_2, file_1, formData_1;
                return append((matchValue_2 = pickedFile, (matchValue_2 == null) ? (empty_2()) : ((file_1 = matchValue_2, (formData_1 = (new FormData()), (formData_1.append(file_1.name, file_1), singleton_1(uploadImage((r) => (new Msg(10, [entityType, entityId, r])), (Item_4) => (new Msg(5, [Item_4])), formData_1))))))), delay(() => collect((url_1) => {
                    let matchValue_3;
                    const matchValue_1 = state.Detail;
                    matchValue_3 = ((matchValue_1.tag === 0) ? undefined : map_1((i_1) => i_1.Id, tryFind_1((i) => {
                        if ((equals(i.Role, new ImageRole(1, [])) && equals(i.EntityType, entityType)) && (i.EntityId === entityId)) {
                            return i.ImageUrl === url_1;
                        }
                        else {
                            return false;
                        }
                    }, matchValue_1.fields[0].Images)));
                    if (matchValue_3 == null) {
                        return empty_2();
                    }
                    else {
                        return singleton_1(removeImage(state.AssignmentNotificationId, matchValue_3, (Item_5) => (new Msg(12, [Item_5])), (Item_6) => (new Msg(5, [Item_6]))));
                    }
                }, removedUrls)));
            }));
            return [new State(state.Notification, state.AssignmentNotificationId, state.Detail, add(entityKey, newFiles, state.SelectedReceiverFilesByEntity), state.Signature, state.SignatureUrl, state.FormState, state.OnConfirm, state.NotificationToolType, state.SelectedProcedureId), Cmd_batch(cmds)];
        }
        case 10: {
            const response_2 = msg.fields[2];
            switch (response_2.tag) {
                case 0:
                    return [state, Cmd_batch(ofArray([loadDetailCmd(state.AssignmentNotificationId), Cmd_errorToast("general.file_too_large")]))];
                case 2:
                    return [state, Cmd_batch(ofArray([loadDetailCmd(state.AssignmentNotificationId), Cmd_errorToast("general.a_error_occured")]))];
                default:
                    return [state, addImage(state.AssignmentNotificationId, new DataTransferObject_AddNotificationImageDto(msg.fields[0], msg.fields[1], new ImageRole(1, []), response_2.fields[0].ImageUrl), (Item_7) => (new Msg(11, [Item_7])), (Item_8) => (new Msg(5, [Item_8])))];
            }
        }
        case 11:
            if (msg.fields[0].tag === 1) {
                return [state, Cmd_batch(ofArray([loadDetailCmd(state.AssignmentNotificationId), Cmd_errorToast("general.a_error_occured")]))];
            }
            else {
                return [state, loadDetailCmd(state.AssignmentNotificationId)];
            }
        case 12:
            if (msg.fields[0].tag === 1) {
                return [state, Cmd_batch(ofArray([loadDetailCmd(state.AssignmentNotificationId), Cmd_errorToast("general.a_error_occured")]))];
            }
            else {
                return [state, loadDetailCmd(state.AssignmentNotificationId)];
            }
        default: {
            const detail = msg.fields[0];
            return [new State(state.Notification, state.AssignmentNotificationId, new RequestedValue$1(1, [detail]), receiverFilesByEntity(detail), state.Signature, state.SignatureUrl, state.FormState, state.OnConfirm, state.NotificationToolType, state.SelectedProcedureId), Cmd_none()];
        }
    }
}

function DialogBody(props) {
    let elems_18;
    const t = useTranslation()[0];
    const patternInput_1 = reactApi.useState(false);
    const setIsSignatureDialogOpen = patternInput_1[1];
    let entities;
    const matchValue = props.Detail;
    entities = ((matchValue.tag === 0) ? empty_1() : matchValue.fields[0].Entities);
    return reactElement("div", createObj(singleton((elems_18 = toList(delay(() => append(singleton_1(createElement(SignatureDialog, {
        Classes: empty_1(),
        Description: "",
        FormState: FormState_get_empty(),
        IsOpen: patternInput_1[0],
        OnClose: () => {
            setIsSignatureDialogOpen(false);
        },
        OnConfirm: (file) => {
            props.Dispatch(new Msg(0, [file]));
            setIsSignatureDialogOpen(false);
        },
    })), delay(() => {
        let elems;
        return append(singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["mb-5"])], (elems = [createElement(TextValue, {
            FontWeight: "normal",
            TestId: "",
            Text: props.Description,
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
            let elems_2, elems_1;
            return append(singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["mb-4"])], (elems_2 = [reactElement("div", {
                className: join(" ", ["text-sm", "font-semibold", "mb-2"]),
                children: t("general.sender"),
            }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "items-center", "mb-2"])], (elems_1 = [createElement(TextValue, {
                FontWeight: "normal",
                TestId: "",
                Text: props.Notification.Sender,
            })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))), delay(() => {
                let elems_7, elems_6;
                return append(!isEmpty(props.Notification.Procedures) ? singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["mb-4"])], (elems_7 = [reactElement("div", {
                    className: join(" ", ["text-sm", "font-semibold", "mb-2"]),
                    children: t("notification.required_procedures"),
                }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-2"])], (elems_6 = toList(delay(() => mapIndexed((index, procedure) => {
                    let elems_5, children;
                    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "items-center", "gap-2"])], (elems_5 = [(children = toList(delay(() => {
                        let elems_3, elems_4;
                        return procedure.IsCompleted ? singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["h-5", "w-5", "text-green"])], (elems_3 = [Check_Circle()], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))) : singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["h-5", "w-5", "text-border"])], (elems_4 = [Check_Circle()], ["children", reactApi.Children.toArray(Array.from(elems_4))])]))));
                    })), reactElement("div", {
                        children: reactApi.Children.toArray(Array.from(children)),
                    })), createElement(TextButton, {
                        ComponentState: "enabled",
                        Label: procedure.TemplateName,
                        OnClick: () => {
                            props.OnOpenProcedure(procedure.Id);
                        },
                        TestId: `open-procedure-button-${index}`,
                        Variant: "blueButton",
                    })], ["children", reactApi.Children.toArray(Array.from(elems_5))])])));
                }, props.Notification.Procedures))), ["children", reactApi.Children.toArray(Array.from(elems_6))])])))], ["children", reactApi.Children.toArray(Array.from(elems_7))])])))) : empty_2(), delay(() => {
                    let elems_9, elems_8;
                    return append((props.Notification.Comment !== "") ? singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["mb-4"])], (elems_9 = [reactElement("div", {
                        className: join(" ", ["text-sm", "font-semibold", "mb-2"]),
                        children: t("general.comment"),
                    }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "items-center", "mb-2"])], (elems_8 = [createElement(TextValue, {
                        FontWeight: "normal",
                        TestId: "",
                        Text: props.Notification.Comment,
                    })], ["children", reactApi.Children.toArray(Array.from(elems_8))])])))], ["children", reactApi.Children.toArray(Array.from(elems_9))])])))) : empty_2(), delay(() => {
                        let matchValue_2, plannedReturnDate, elems_11, elems_10;
                        return append((matchValue_2 = props.Notification.PlannedReturnDate, (matchValue_2 == null) ? (empty_2()) : ((plannedReturnDate = matchValue_2, singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["mb-4"])], (elems_11 = [reactElement("div", {
                            className: join(" ", ["text-sm", "font-semibold", "mb-2"]),
                            children: t("tool.planned_return_date"),
                        }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "items-center", "mb-2"])], (elems_10 = [createElement(TextValue, {
                            FontWeight: "normal",
                            TestId: "",
                            Text: toString(toLocalTime(plannedReturnDate), "dd.MM.yyyy"),
                        })], ["children", reactApi.Children.toArray(Array.from(elems_10))])])))], ["children", reactApi.Children.toArray(Array.from(elems_11))])]))))))), delay(() => append(collect((entity) => {
                            let elems_14;
                            let entitySenderImages;
                            const matchValue_1 = props.Detail;
                            entitySenderImages = ((matchValue_1.tag === 0) ? empty_1() : filter((i) => {
                                if (equals(i.Role, new ImageRole(0, [])) && equals(i.EntityType, entity.EntityType)) {
                                    return i.EntityId === entity.EntityId;
                                }
                                else {
                                    return false;
                                }
                            }, matchValue_1.fields[0].Images));
                            const receiverFiles = defaultArg(tryFind([entity.EntityType, entity.EntityId], props.SelectedReceiverFilesByEntity), empty_1());
                            return singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["mb-4"])], (elems_14 = toList(delay(() => {
                                let elems_12;
                                return append(!isEmpty(entitySenderImages) ? singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["mb-3"])], (elems_12 = [reactElement("div", {
                                    className: join(" ", ["text-sm", "font-semibold", "mb-2"]),
                                    children: t("assignment_notification.sender_images"),
                                }), createElement(ClickableImageStrip, {
                                    ImageClasses: ofArray(["h-20", "w-20"]),
                                    Images: map((image) => ({
                                        Url: image.ImageUrl,
                                    }), entitySenderImages),
                                })], ["children", reactApi.Children.toArray(Array.from(elems_12))])])))) : empty_2(), delay(() => {
                                    let elems_13;
                                    return singleton_1(reactElement("div", createObj(singleton((elems_13 = [reactElement("div", {
                                        className: join(" ", ["text-sm", "font-semibold", "mb-2"]),
                                        children: t("assignment_notification.receiver_images"),
                                    }), createElement(ImageUpload, {
                                        ComponentState: props.ComponentState,
                                        SelectedFiles: receiverFiles,
                                        SetSelectedFile: (files) => {
                                            props.Dispatch(new Msg(9, [entity.EntityType, entity.EntityId, files]));
                                        },
                                    })], ["children", reactApi.Children.toArray(Array.from(elems_13))])))));
                                }));
                            })), ["children", reactApi.Children.toArray(Array.from(elems_14))])]))));
                        }, entities), delay(() => {
                            let elems_17;
                            return append(props.Notification.WithSignature ? singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["mb-4"])], (elems_17 = toList(delay(() => append(singleton_1(reactElement("div", {
                                className: join(" ", ["text-sm", "font-semibold", "mb-2"]),
                                children: t("general.signature"),
                            })), delay(() => {
                                let elems_16, elems_15;
                                const matchValue_3 = props.Signature;
                                if (matchValue_3 == null) {
                                    return append(singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "items-center", "mb-2"])], (elems_16 = [createElement(TextValue, {
                                        FontWeight: "normal",
                                        TestId: "",
                                        Text: t("notification.signature_description"),
                                    })], ["children", reactApi.Children.toArray(Array.from(elems_16))])])))), delay(() => singleton_1(createElement(TextButton, {
                                        ComponentState: props.ComponentState,
                                        Label: t("notification.sign"),
                                        OnClick: () => {
                                            setIsSignatureDialogOpen(true);
                                        },
                                        TestId: "switch-storage-text-button-test-id",
                                        Variant: "blueButton",
                                    }))));
                                }
                                else {
                                    const signature = matchValue_3;
                                    const imageUrl = URL.createObjectURL(signature);
                                    return singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems_15 = [reactElement("img", {
                                        className: join(" ", ["h-24"]),
                                        src: imageUrl,
                                    })], ["children", reactApi.Children.toArray(Array.from(elems_15))])]))));
                                }
                            })))), ["children", reactApi.Children.toArray(Array.from(elems_17))])])))) : empty_2(), delay(() => {
                                const matchValue_4 = FormState__getValidation(props.FormState, t, "global");
                                if (matchValue_4 == null) {
                                    return empty_2();
                                }
                                else {
                                    return singleton_1(createElement(ErrorAlert, {
                                        Label: matchValue_4,
                                    }));
                                }
                            }));
                        }))));
                    }));
                }));
            }));
        }));
    })))), ["children", reactApi.Children.toArray(Array.from(elems_18))]))));
}

export function AcceptNotificationDialog(props) {
    const t = useTranslation()[0];
    const patternInput_1 = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init(props.NotificationToolType, props.Notification, props.OnConfirm), update, (_arg_1, _arg_1_1) => {
    }), undefined, [props.IsOpen]);
    const state_1 = patternInput_1[0];
    const dispatch = patternInput_1[1];
    const componentState = state_1.FormState.IsLoading ? "disabled" : "enabled";
    const xs = toList(delay(() => {
        let matchValue, procedureId;
        return append((matchValue = state_1.SelectedProcedureId, (matchValue == null) ? (empty_2()) : ((procedureId = matchValue, singleton_1(createElement(OpenProcedureModal, {
            IsOpen: true,
            OnCancelCallback: () => {
                dispatch(new Msg(6, [undefined]));
            },
            OnClose: () => {
                dispatch(new Msg(6, [undefined]));
            },
            OnSuccessCallback: () => {
                dispatch(new Msg(7, [procedureId]));
            },
            ProcedureId: new ProcedureId(parse(procedureId)),
        }))))), delay(() => {
            let Title;
            return singleton_1(createElement(Dialog, (Title = t("notification.accept"), {
                Body: singleton(createElement(DialogBody, {
                    ComponentState: componentState,
                    Description: props.Description,
                    Detail: state_1.Detail,
                    Dispatch: dispatch,
                    FormState: state_1.FormState,
                    Notification: state_1.Notification,
                    OnOpenProcedure: (procedureId_1) => {
                        dispatch(new Msg(6, [procedureId_1]));
                    },
                    SelectedReceiverFilesByEntity: state_1.SelectedReceiverFilesByEntity,
                    Signature: unwrap(state_1.Signature),
                })),
                Controls: ofArray([createElement(TextButton, {
                    ComponentState: componentState,
                    Label: t("general.cancel"),
                    OnClick: props.OnClose,
                    TestId: "close-accept-notification-dialog-test-id",
                    Variant: "blueButton",
                }), createElement(TextButton, {
                    ComponentState: (state_1.Notification.WithSignature && (state_1.Signature == null)) ? "disabled" : componentState,
                    Label: t("notification.accept"),
                    OnClick: () => {
                        if (state_1.Notification.WithSignature && (state_1.Signature != null)) {
                            dispatch(new Msg(1, []));
                        }
                        else {
                            dispatch(new Msg(3, []));
                        }
                    },
                    TestId: "accept-notification-dialog-test-id",
                    Variant: "blueButton",
                })]),
                IsOpen: props.IsOpen,
                OnClose: props.OnClose,
                Title: Title,
            })));
        }));
    }));
    return react.createElement(react.Fragment, {}, ...xs);
}

